/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AccountResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UserDTO, RequestOptions, PersistentToken } from "../models";

@Injectable({ providedIn: "root" })
export class AccountResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    registerAccount(userDTO: UserDTO, observe?: 'body', options?: RequestOptions<'text'>): Observable<Record<string, any>>;
    registerAccount(userDTO: UserDTO, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<Record<string, any>>>;
    registerAccount(userDTO: UserDTO, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<Record<string, any>>>;
    registerAccount(userDTO: UserDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/register`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'text/plain');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: userDTO,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAccount(observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    getAccount(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    getAccount(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    getAccount(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    saveAccount(userDTO: UserDTO, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    saveAccount(userDTO: UserDTO, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    saveAccount(userDTO: UserDTO, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    saveAccount(userDTO: UserDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: userDTO,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    requestPasswordReset(requestBody: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<Record<string, any>>;
    requestPasswordReset(requestBody: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<Record<string, any>>>;
    requestPasswordReset(requestBody: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<Record<string, any>>>;
    requestPasswordReset(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account/reset_password/init`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'text/plain');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    finishPasswordReset(key: string, newPassword: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    finishPasswordReset(key: string, newPassword: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    finishPasswordReset(key: string, newPassword: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    finishPasswordReset(key: string, newPassword: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account/reset_password/finish`;

        let params = new HttpParams();
        if (key != null) {
            params = HttpParamsBuilder.addToHttpParams(params, key, 'key');
        }
        if (newPassword != null) {
            params = HttpParamsBuilder.addToHttpParams(params, newPassword, 'newPassword');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changePassword(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Record<string, any>>;
    changePassword(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Record<string, any>>>;
    changePassword(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Record<string, any>>>;
    changePassword(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account/change_password`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    isAuthenticated(observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    isAuthenticated(observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    isAuthenticated(observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    isAuthenticated(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/authenticate`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    activateAccount(key: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    activateAccount(key: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    activateAccount(key: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    activateAccount(key: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/activate`;

        let params = new HttpParams();
        if (key != null) {
            params = HttpParamsBuilder.addToHttpParams(params, key, 'key');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getCurrentSessions(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PersistentToken>>;
    getCurrentSessions(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PersistentToken>>>;
    getCurrentSessions(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PersistentToken>>>;
    getCurrentSessions(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account/sessions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    invalidateSession(series: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    invalidateSession(series: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    invalidateSession(series: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    invalidateSession(series: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/account/sessions/${series}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
